<template>
	<div class="stationedUnitTooltip">
		<h3>
			<span v-if="unitId == 1">Дубинщик</span>
			<span v-if="unitId == 2">Копейщик</span>
			<span v-if="unitId == 3">Мечник</span>
			<span v-if="unitId == 4">Топорщик</span>
			<span v-if="unitId == 5">Лучник</span>
			<span v-if="unitId == 6">Следопыт</span>
			<span v-if="unitId == 7">Легкий кавалерист</span>
			<span v-if="unitId == 8">Тяжелый кавалерист</span>
			<span v-if="unitId == 9">Конный лучник</span>
			<span v-if="unitId == 10">Таран</span>
			<span v-if="unitId == 11">Катапульта</span>
			<span v-if="unitId == 12">Предводитель</span>
			<span v-if="unitId == 13">Поселенец</span>
			<span v-if="unitId == 14">Герой</span>
			<!-- ngIf: group.unitLevels[unitId] -->
		</h3>
		<div class="horizontalLine"></div>
		<div class="troopDetails">
			<div class="troopIcon">
				<i class="unitMedium gaul" :class="['unitType'+unitId]"></i>
			</div>
			<div class="unitAttributes">
				<span><i class="movement_attack_small_flat_black"></i>65</span>
				<span><i class="unit_defenseInfantry_small_flat_black"></i>35</span>
				<br>
				<span><i class="unit_defenseCavalry_small_flat_black"></i>20</span>
				<span><i class="unit_capacity_small_flat_black"></i>45</span>
			</div>
		</div>
		<div class="homeTroops troopDetails" v-if="distributionOwn">
			<div class="horizontalLine"></div>
			<div class="playerNameVillageNameWrapper">
				<div class="playerName">
					<a class="playerLink truncated clickable disabled">{{distributionOwn.player}}</a>
				</div>
				<div class="villageName">
					<a class="villageLink truncated clickable disabled">{{distributionOwn.island}}</a>
				</div>
			</div>
			<div class="amount" v-if="unitId != Troops.TYPE_HERO">{{distributionOwn.count||0}}</div>
			<div class="heroLevel" v-else>
				<span>Ур.</span>
				<span class="level">{{distributionOwn.count||0}}</span>
			</div>
		</div>
		<div class="homeTroops troopDetails" v-for="(support, index) in distributionSupport" :key="index">
			<div class="horizontalLine"></div>
			<div class="playerNameVillageNameWrapper">
				<div class="playerName">
				<a class="playerLink truncated clickable disabled">{{support.player}}</a>
				</div>
				<div class="villageName">
					<a class="villageLink truncated clickable disabled">{{support.island}}</a>
				</div>
			</div>
			<div class="amount">{{support.count||0}}</div>
		</div>
		<!-- ngIf: unit['distribution']['others']['sum'] > 0 -->
	</div>
</template>

<style lang="scss" scoped>
	
</style>

<script>
import lib from '@/lib';

import Troops from '@/classes/game/Troops';

export default {
	mixins: lib.mixins,
	data: () => ({
		Troops,
	}),
	props: {
		unitId: {
			type: Number,
			required: true,
		},
		count: {
			type: Number,
			default: 0,
		},
		playerUsername: {
			type: String,
			default: '',
		},
		distributionOwn: {
			type: Object,
			default: () => ({}),
		},
		distributionSupport: {
			type: Array,
			default: () => [],
		},
	},
}
</script>